module.exports = __webpack_public_path__ + "img/tutorial_title02.28162bb5.svg";